export default "__VITE_ASSET__af0f1156__"